import { render, staticRenderFns } from "./wy-va-optimization-response-name-cell.vue?vue&type=template&id=4924c2f8&"
import script from "./wy-va-optimization-response-name-cell.vue?vue&type=script&lang=js&"
export * from "./wy-va-optimization-response-name-cell.vue?vue&type=script&lang=js&"
import style0 from "./wy-va-optimization-response-name-cell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports